import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import config from '../../config';
import { checkIfLoggedIn, checkIfCanAccessStats } from '../../actions/auth';
import NoAccessScreen from '../../containers/NoAccessScreen';

class PrivateRoute extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(checkIfLoggedIn());
    dispatch(checkIfCanAccessStats());
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { path: prevPath } = prevProps;
    const { dispatch, path } = this.props;

    if (prevPath !== path) {
      dispatch(checkIfLoggedIn());
      dispatch(checkIfCanAccessStats());
    }
  }

  render() {
    const {
      hasLoadedIsLoggedIn,
      isLoggedIn,
      hasLoadedCanAccessStats,
      canAccessStats,
      component: Component,
      ...rest
    } = this.props;
    return (
        <Route
            {...rest}
            render={(props) => {
              if (hasLoadedIsLoggedIn && !isLoggedIn) {
                window.location.href = `${config.getAppUrl()}/accounts/login/?next=/statisticstool/redirect`;
                return null;
              }
              if (hasLoadedCanAccessStats && !canAccessStats) {
                return <NoAccessScreen />;
              }
              if (!hasLoadedIsLoggedIn || !hasLoadedCanAccessStats) {
                return null;
              }
              return <Component {...props} />;
            }}
        />
    );
  }
}

PrivateRoute.propTypes = {
    component: PropTypes.any.isRequired,
    location: PropTypes.object
};

const mapStateToProps = (state) => ({
  hasLoadedIsLoggedIn: state.auth.hasLoadedIsLoggedIn,
  isLoggedIn: state.auth.isLoggedIn,
  hasLoadedCanAccessStats: state.auth.hasLoadedCanAccessStats,
  canAccessStats: state.auth.canAccessStats,
});

export default connect(mapStateToProps)(PrivateRoute);

